var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[[_c('courses-table-tab')]],2)}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9f487dd8","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./src/components/user/courses/courses-tabs/courses.html
// module id = null
// module chunks = 